export * from './NavLinkTabs';
export * from './NavLinkTabs.type';
